module.exports = __webpack_public_path__ + "img/桌球、女桌.5138a1ce.jpg";